import { ArrowLeft, Pencil } from "lucide-react";
import {
  ActionIcon,
  Drawer,
  Group,
  LoadingOverlay,
  ScrollArea,
  Space,
  Text,
} from "@mantine/core";
import React, { useEffect, useState } from "react";
import { HttpClientError } from "../../../providers/HttpClient";
import useSurveyDetailsApiService from "../services/api/SurveyDetailsApiService";
import SurveyForm from "../components/SurveyForm";
import { useToasts } from "../../../providers/notifications/ToastsContext";

type UpdateSurveyActionIconProps = {
  id: number;
};

const UpdateSurveyActionIcon: React.FC<UpdateSurveyActionIconProps> = ({
  id,
}) => {
  const {
    isLoading,
    isError,
    error,
    refetch,
    isRefetchError,
    isSuccess,
    data,
  } = useSurveyDetailsApiService(id, false);
  const { showToast } = useToasts();

  const [opened, setOpened] = useState(false);

  useEffect(() => {
    if (isError || isRefetchError) {
      showToast({
        strapiId: "update_survey_error",
        data: {
          message: HttpClientError(error),
        },
      });

      setOpened(false);
    }
  }, [isError, error]);

  useEffect(() => {
    if (opened) {
      refetch().then();
    }
  }, [opened]);

  return (
    <>
      <LoadingOverlay visible={isLoading} />
      <Drawer
        opened={isSuccess && opened}
        onClose={() => setOpened(false)}
        size="full"
        styles={{
          header: {
            backgroundColor: "#ffffff",
          },
          title: { width: "100%" },
          drawer: {
            backgroundColor: "#f7f7f8",
          },
        }}
        title={
          <Group
            position="apart"
            spacing="xl"
            style={{
              width: "100%",
            }}
          >
            <Group spacing="xl">
              <ActionIcon onClick={() => setOpened(false)}>
                <ArrowLeft />
              </ActionIcon>
              <Text className="Heading">{data?.title}</Text>
            </Group>
            <Group spacing="xl">
              <Text
                style={{
                  flexGrow: 0,
                  fontSize: "18px",
                  fontWeight: 500,
                  fontStretch: "normal",
                  fontStyle: "normal",
                  lineHeight: "normal",
                  letterSpacing: "0.16px",
                  textAlign: "left",
                }}
              >
                Survey Details
              </Text>

              <Space w="lg" />
              <Space w="lg" />
              <Space w="md" />
              <Space w="sm" />
            </Group>
          </Group>
        }
        overlayOpacity={0.1}
        overlayBlur={3}
        position="right"
      >
        <ScrollArea
          style={{
            backgroundColor: "#f7f7f8",
            height: "800px",
          }}
        >
          <SurveyForm values={data} onSuccess={() => setOpened(false)} />
        </ScrollArea>
      </Drawer>
      <ActionIcon onClick={() => setOpened(true)}>
        <Pencil size={18} />
      </ActionIcon>
    </>
  );
};

export default UpdateSurveyActionIcon;
